
import application from './application';
import addApplication from './addApplication';
import location from './location';
import toolbar from './toolbar';

let component = {
  application,
  addApplication,
  location,
  toolbar
};

const install = (Vue) => {
  Object.keys(component).forEach((key) => {
    Vue.component(`x-${key}`, component[key]);
  });
};

export default install;
